import React from 'react';

const UseApps = ({ useAppsInfo, styles = {} }) => {
  return (
    <section className={`index-use-apps ${styles.useAppsSection}`}>
      <div className="container-block index-use-apps-inner">
        <figure className="index-use-apps-phone">
          <picture>
            <source srcSet={useAppsInfo.iphoneImgPng.img} type={useAppsInfo.typePng} />
            <img
              className="index-use-apps-phone-silver-bg"
              alt={useAppsInfo.iphoneImgPng.alt}
              title={useAppsInfo.title}
              src={useAppsInfo.iphoneImgPng.img}
              loading="lazy"
            />
          </picture>
          <picture>
            <source srcSet={useAppsInfo.appScreen.img} type={useAppsInfo.typePng} />
            <img
              alt={useAppsInfo.appScreen.alt}
              title={useAppsInfo.title}
              className="index-use-apps-inner-img"
              src={useAppsInfo.appScreen.img}
            />
          </picture>
        </figure>
        <div className="index-use-apps-content">
          <h2 className="index-white-heading">{useAppsInfo.useAppContent.textH2}</h2>
          <p className="index-header-text">{useAppsInfo.useAppContent.textP}</p>
          <div className="index-use-apps-horizontal">
            <a
              className="app-link"
              href={useAppsInfo.useAppContent.linkAppStore}
              target="_blank"
              rel="noopener noreferrer"
            >
              <picture>
                <source srcSet={useAppsInfo.useAppContent.appStoreImg} type="image/png" />
                <img
                  src={useAppsInfo.useAppContent.appStoreImg}
                  alt={useAppsInfo.useAppContent.appStoreTitle}
                  title={useAppsInfo.useAppContent.appStoreTitle}
                />
              </picture>
            </a>
            <a
              className="app-link"
              href={useAppsInfo.useAppContent.linkGplay}
              target="_blank"
              rel="noopener noreferrer"
            >
              <picture>
                <source srcSet={useAppsInfo.useAppContent.gPlayImg} type="image/png" />
                <img
                  className="app-link-img-android"
                  src={useAppsInfo.useAppContent.gPlayImg}
                  alt={useAppsInfo.useAppContent.gPlayTitle}
                  title={useAppsInfo.useAppContent.gPlayTitle}
                  height="54px"
                  width="166px"
                />
              </picture>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UseApps;
